import React, { useEffect, useRef, useState } from "react";
import { fetchIndeeProjects, logout } from "../../utils/api/helpers/indee";
import { Modal } from "../../utils/Ui/Modal";
import { ScreenerAccordion } from "./ScreenerAccordion";
import spinner from "../../assets/ico/spinner.gif";

import {
  setDisplayScreenerLogin,
  useDisplayScreenerProjectList,
  setDisplayScreenerProjectList,
  useActiveTitleName,
  useActiveProjectKey,
  useLoggingOut,
  setLoggingOut,
  setScreenerLoggedIn,
  setAuthActionFlag,
  setActiveProjectKey,
  setActiveTitleName,
  setAuthComplete,
  setSuccess,
} from "../../utils/Screeners/useScreeners";

import {
  // useAllVideoPaused,
  setAllVideoPaused,
} from "../../utils/Home/homeStates";
import { toggleAllVideos } from "../../utils/Actions/toggleAllVideos";

export const ScreenerProjectList = () => {
  const activeTitleName = useActiveTitleName();
  const activeProjectKey = useActiveProjectKey();

  const displayScreenerProjectList = useDisplayScreenerProjectList();
  const loggingOut = useLoggingOut();

  // const allVideoPaused = useAllVideoPaused();

  const [loaded, setLoaded] = useState(false),
    [projectCount, setProjectCount] = useState(0),
    [projectList, setProjectList] = useState([]),
    [projectKeyInList, setProjectKeyInList] = useState(true);

  const modalContentRef = useRef(null);

  useEffect(() => {
    if (displayScreenerProjectList) {
      setAllVideoPaused(true);
      toggleAllVideos(true);
    } else {
      setAllVideoPaused(false);
      toggleAllVideos(false);
    }
  }, [displayScreenerProjectList]);

  const doLogout = () => {
    setLoggingOut(true);
    logout().then(() => {
      setTimeout(() => {
        setLoggingOut(false);
        setAuthActionFlag(false);
        setDisplayScreenerProjectList(false);
        setActiveProjectKey(null);
        setActiveTitleName(null);
        setScreenerLoggedIn(false);
        setAuthComplete(false);
        setSuccess(false);
        window.location.reload();
      }, 500);
    });
  };

  const LogoutIcon = ({
    size = 24,
    strokeWidth = 2,
    color = "currentColor",
    ...props
  }) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="#fff"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}
      >
        <path
          className="st0"
          d="M17.41,7.42v30.34h11.35c.44,0,1.28-.78,1.46-1.18.51-1.1.09-4.01.21-5.39.24-2.77,4.14-2.86,4.38.2.39,4.96-.21,9.96-6.06,10.75h-11.29c-.82,2.59-2.96,3.95-5.67,3.3-2.06-.49-5.49-1.68-7.49-2.49C1.81,41.93.24,39.83,0,37.1V10.01C.19,3.86,7.36,2.97,11.54.28c1.8-.69,3.85-.06,5,1.45.32.42.44.88.74,1.3l11.59.02c5.78.87,6.3,5.72,5.96,10.64-.1,1.47-.99,2.58-2.57,2.36-3.31-.46-.84-5.97-2.26-7.81-.2-.25-.93-.81-1.22-.81h-11.35ZM13.04,4.47l-7.67,3.78c-.63.45-.99,1.07-.99,1.86.08,9.12-.14,18.28.11,27.38.18.66.74,1.14,1.35,1.4l7.2,2.32V4.47Z"
        />
        <path
          className="st0"
          d="M40.32,24.73h-16.95c-.05,0-.46-.21-.55-.26-1.4-.77-1.4-2.98,0-3.75.1-.05.5-.26.55-.26h16.95c-.24-.59-.83-.78-1.07-1.43-.76-2.06,1.64-3.85,3.41-2.49.96.74,3.87,3.66,4.63,4.63s.73,1.93,0,2.85-3.67,3.9-4.63,4.63c-2.02,1.54-4.53-.94-3.2-2.9.24-.35.77-.6.86-1.02Z"
        />
      </svg>
    );
  };

  useEffect(() => {
    if (!loaded && displayScreenerProjectList) {
      fetchIndeeProjects().then((result) => {
        // console.log("fetchIndeeProjects project list", result);
        setLoaded(true);
        if (result.data.error && result.data.message.unauth) {
          setDisplayScreenerProjectList(false);
          setDisplayScreenerLogin(true);
        } else {
          setProjectCount(result.data.count);
          setProjectList(result.data.results);
          // console.log('project list',result.data, activeProjectKey, activeTitleName)
        }
      });
    }
  }, [loaded, displayScreenerProjectList, activeProjectKey, activeTitleName]);

  useEffect(() => {
    if (activeProjectKey && displayScreenerProjectList) {
      // console.log(projectList)
      if (projectList.some((e) => e.key === activeProjectKey)) {
        setProjectKeyInList(true);
        // console.log('project exists')
        const elmnt = document.getElementById(activeProjectKey);
        elmnt?.scrollIntoView();
      } else {
        setProjectKeyInList(false);
        // console.log('project does NOT exist')
      }
    }
  }, [activeProjectKey, projectList, displayScreenerProjectList]);

  if (!displayScreenerProjectList) {
    return null;
  }

  return (
    <>
      <Modal
        scrollable={true}
        isOpen={displayScreenerProjectList}
        onClose={() => {
          setDisplayScreenerProjectList(false);
        }}
        size="threeQuarter"
        contentScrollRef={modalContentRef}
        header={
          <div
            className={
              "d-flex align-items-center justify-content-center flex-fill"
            }
          >
            <div
              className={
                "d-flex align-items-center justify-content-center pe-3"
              }
            >
              <img
                src={"/img/netflix-logo-ribbon.png"}
                className="header__logo"
                alt="Netflix"
                style={{ maxWidth: "15px" }}
              />
            </div>
            <div className={"d-flex align-items-center justify-content-center"}>
              <span
                className={""}
                style={{
                  fontSize: ".75rem",
                  letterSpacing: "0.15em",
                  textTransform: "uppercase",
                  fontWeight: "300",
                }}
              >
                FYC | Screeners
              </span>
            </div>
            <div
              className={
                "d-flex align-items-center justify-content-center ms-auto"
              }
            >
              <span
                onClick={() => {
                  doLogout();
                }}
                className={"me-2 logout-button"}
              >
                <span className={"logout-button-label"}>
                  {loggingOut ? "Signing Out..." : "Sign Out"}
                </span>{" "}
                <LogoutIcon size={24} color="#fff" />
              </span>
            </div>
          </div>
        }
      >
        <>
          {loaded ? (
            <>
              {!projectKeyInList && activeProjectKey && activeTitleName ? (
                <div
                  className={"my-4"}
                  style={{
                    color: "#ccc",
                    backgroundColor: "rgba(255,255,255,.05)",
                    borderRadius: 7,
                    padding: "1.5rem",
                  }}
                >
                  Your code does not have access to screeners for{" "}
                  <strong>{activeTitleName}</strong>. Please see below for your
                  list of available Screeners.
                </div>
              ) : null}

              {projectCount > 0 ? (
                <ScreenerAccordion
                  defaultActiveKey={activeProjectKey || null}
                  items={projectList}
                  scrollParentRef={modalContentRef}
                />
              ) : (
                <div className={"my-4"} style={{ color: "#ccc" }}>
                  Your code does not have access to Screeners at this time.
                </div>
              )}
            </>
          ) : (
            <div className={"component-loader"}>
              <div className="component-loader-inner ">
                <img
                  src={spinner}
                  alt="Loading"
                  className="page-loader-spinner"
                />
              </div>
            </div>
          )}
        </>
      </Modal>
    </>
  );
};
